import { render, staticRenderFns } from "./node-settings.vue?vue&type=template&id=28787620&lang=pug&"
import script from "./node-settings.vue?vue&type=script&lang=js&"
export * from "./node-settings.vue?vue&type=script&lang=js&"
import style0 from "./node-settings.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "node-settings.vue"
export default component.exports